import React, { useEffect, useState } from 'react';
import Turnstile,{useTurnstile} from "react-turnstile"
import CenteredToast from '../common/centeredToast';
import { Snackbar, Alert, Link } from '@mui/material';
import { useRef } from 'react';
import  LoginTg  from './loginTg.jsx';

import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TextField,
  Tabs,
  Tab,
  Box,
  Stack,
  Typography,
  CircularProgress
} from '@mui/material';

import { DOMAIN } from '../../config'
import UserProfile from './userProfile'
import {useUser} from "../../contexts/userContext.jsx" 



const sendPostRequest = async (url,data) => {
  try {
    const response = await fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(data),
    });

    if (!response.ok) {
      throw new Error('网络响应不是 OK');
    }

    const result = await response.json()
    return result
  } catch (error) {
    console.error('出错:', error);
  }
};

export default function LoginRegisterDialog  ({ open, onClose, onSuccess=null }) {
  const [activeTab, setActiveTab] = useState(0);
  const [isTg,setIsTg] = useState(false)
  const [tuser,setTuser] = useState({})
  const { userData } = useUser();

  const handleTabChange = (event, newValue) => {
    setActiveTab(newValue);
  }

   useEffect(()=>{
        window.Telegram.WebApp.ready() 
        const tel_user = window.Telegram.WebApp.initDataUnsafe
        if(Object.keys(tel_user).length != 0){
          setIsTg(true)
          setTuser(tel_user)
        }   
    },[])

  return (
    <Dialog open={open} onClose={onClose}>
      {
        isTg?<LoginTg tuser={tuser} activeTab={activeTab} handleTabChange={handleTabChange} onClose={onClose}/>:
        <LoginWeb onSuccess={onSuccess} activeTab={activeTab} handleTabChange={handleTabChange} onClose={onClose}/>
      }
      
    </Dialog>
  );
}


function LoginWeb({ activeTab, handleTabChange, onClose, onSuccess }) {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  

  const [usernameError, setUsernameError] = useState('');
  const [passwordError, setPasswordError] = useState('');
  const [confirmPasswordError, setConfirmPasswordError] = useState('');
  const [pendingField, setPendingField] = useState(null);

  const [turnstileToken, setTurnstileToken] = useState('');
  const [turnstileError, setTurnstileError] = useState('');
  const [aid, setAid] = useState('');
  const [showToast, setShowToast] = useState(false);
  const [showToastLogin, setShowToastLogin] = useState(false);
  const [showToastLoginFalse, setShowToastLoginFalse] = useState(false);
  const [cookie, setCookie] = useState();
  const [isLoading, setIsLoading] = useState(true);
  const [signInMessage, setSignInMessage] = useState('');
  const [signInOpen, setSignInOpen] = useState(false);
  const { setUserData } = useUser();

  

  const turnstileRef = useRef(null);

  const parseTimestamp = (timestamp) => {
    timestamp = timestamp * 1000;
    let date = new Date(timestamp);
    date.setHours(date.getHours() + 8);
    const y = date.getFullYear();
    const m = String(date.getMonth() + 1).padStart(2, '0');
    const d = String(date.getDate()).padStart(2, '0');
    const h = String(date.getHours()).padStart(2, '0');
    const min = String(date.getMinutes()).padStart(2, '0');
    const s = String(date.getSeconds()).padStart(2, '0');
    return `${y}-${m}-${d} ${h}:${min}:${s}`;
  };

  useEffect(() => {
    const queryParams = new URLSearchParams(window.location.search);
    const aid = queryParams.get('aid');
    if (aid) setAid(aid);

    fetch(`${DOMAIN}ywyminiappbot/getcookie`, {
      credentials: 'include',
    })
      .then((res) => res.json())
      .then((data) => {
        if (data.state === true) {
          const vipTime = parseTimestamp(data.timestart + data.days * 86400);
          data["expire"] = vipTime;

          setUserData(data)
          setCookie(data);
        } else {
          setCookie(null);
        }
      })
      .catch(() => setCookie(null))
      .finally(() => setIsLoading(false));
  }, []);

  useEffect(() => {
    if (pendingField) {
      handleSubmitSingle(pendingField);
      setPendingField(null);
    }
  }, [pendingField]);

  const handleSubmitSingle = async (typing) => {
    let valid = true;
    setUsernameError('');
    setPasswordError('');
    setConfirmPasswordError('');

    if (typing === "username" && username.length >= 6 && username.length <= 20) {
      const res = await fetch(`${DOMAIN}ywyminiappbot/checkusername?username=${username}`);
      const data = await res.json();
      if (data.length !== 0) {
        setUsernameError('此用户名已经被注册了');
        valid = false;
      }
    }

    if (username.length < 4 && typing === "username") {
      setUsernameError('用户名必须大于4位');
      valid = false;
    }
    if (username.length > 11 && typing === "username") {
      setUsernameError('用户名不能大于11位');
      valid = false;
    }

    if (password.length < 6 && typing === "password") {
      setPasswordError('密码必须大于6位');
      valid = false;
    }
    if (password.length > 15 && typing === "password") {
      setPasswordError('密码不能大于15位');
      valid = false;
    }

    if (password !== confirmPassword && typing === "confirmPassword") {
      setConfirmPasswordError('两次密码输入不一致');
      valid = false;
    }
  };

  const handleSubmit = async () => {
    let valid = true;
    setUsernameError('');
    setPasswordError('');
    setConfirmPasswordError('');
    setTurnstileError('');

    if (username.length >= 6 && username.length <= 20) {
      const res = await fetch(`${DOMAIN}ywyminiappbot/checkusername?username=${username}`);
      const data = await res.json();
      if (data.length !== 0) {
        setUsernameError('此用户名已经被注册了');
        valid = false;
      }
    }

    if (username.length < 4) {
      setUsernameError('用户名必须大于4位');
      valid = false;
    }
    if (username.length > 11) {
      setUsernameError('用户名不能大于11位');
      valid = false;
    }
    if (password.length < 6) {
      setPasswordError('密码必须大于6位');
      valid = false;
    }
    if (password.length > 15) {
      setPasswordError('密码不能大于15位');
      valid = false;
    }
    if (password !== confirmPassword) {
      setConfirmPasswordError('两次密码输入不一致');
      valid = false;
    }
    if (!turnstileToken) {
      setTurnstileError('请完成人机验证');
      valid = false;
    }

    if (valid) {
      const res = await fetch(`${DOMAIN}ywyminiappbot/userRegisterWeb`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        credentials: 'include',
        body: JSON.stringify({ aid, username, password, turnstileToken })
      });
      console.log(res)
      setShowToast(true);
      if (!res.ok) return;

      const data = await res.json();
      if (onSuccess) onSuccess(data);

      const timer = setTimeout(() => onClose(), 1000);
      return () => clearTimeout(timer);
    }
  };

  const handleLogin = async () => {
    let valid = true;
    setUsernameError('');
    setPasswordError('');
    setConfirmPasswordError('');
    setTurnstileError('');

    if (!turnstileToken) {
      setTurnstileError('请完成人机验证');
      valid = false;
    }

    if (valid) {
      try {
        const res = await fetch(`${DOMAIN}ywyminiappbot/userLoginWeb`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          credentials: 'include',
          body: JSON.stringify({ aid, username, password, turnstileToken }),
        });

        if (!res.ok) throw new Error(`网络错误：${res.status}`);
        const data = await res.json();

        if (data.state) {
          
          setUserData(data.user)
          setShowToastLogin(true);
          if (onSuccess) onSuccess(data);
          const timer = setTimeout(() => onClose(), 1000);
          return () => clearTimeout(timer);
        } else {
          setShowToastLoginFalse(true);
          setUsername('');
          setPassword('');
          const timer = setTimeout(() => onClose(), 1000);
          return () => clearTimeout(timer);
        }
      } catch (err) {
        console.error('登录失败:', err);
      }
    }
  };

  const onLogout = async () => {
    const confirmed = window.confirm('确定要退出登录吗？');
    if (!confirmed) return;
  
    try {
      const res = await fetch(`${DOMAIN}ywyminiappbot/logout`, {
        method: 'GET',
        credentials: 'include',
      });
  
      const data = await res.json();
      if (data.success) {
        console.log('已成功退出登录');
        setCookie(null); // 清除本地状态或触发 UI 更新
        setUserData(null)
      } else {
        console.error('退出登录失败:', data.message);
      }
    } catch (err) {
      console.error('请求出错:', err);
    }
  };
  
  const onSignIn = async () => {
    setCookie(prev => ({
      ...prev,
      sign: true,
      silver: prev?.silver + 1, // 假设每次签到加1
    }))

    try {
      const res = await fetch(`${DOMAIN}ywyminiappbot/userSign`, {
        method: 'GET',
        credentials: 'include',
      });
  
      const data = await res.json();
  
      setSignInMessage(data.state ? '签到成功' : '已经签到过了，请明天再来')
      setSignInOpen(true);
      
  
      // 可选：调用回调或更新状态
      // if (data.state) setHasSignedIn(true);
  
    } catch (err) {
      console.error('请求出错:', err);
      setSignInMessage('网络错误，请稍后再试');
      setSignInOpen(true);
    }
  }

  const onVerify = async () => {
    const encodedUsername = base64urlEncode(cookie.username);
    const encodedPassword = base64urlEncode(cookie.password);

    const url = `https://t.me/ywydizhibot?start=type_cU-usr_${encodedUsername}-pas_${encodedPassword}`;
    // ✅ 在新标签页中打开 Telegram 链接
    window.open(url, "_blank");
  };

  function base64urlEncode(str) {
    return btoa(str)                 // 普通 base64
      .replace(/\+/g, "-")           // 替换 +
      .replace(/\//g, "_")           // 替换 /
      .replace(/=+$/, "");           // 去掉末尾 =
  }


  return (
    <>
       <Snackbar
        open={signInOpen}
        autoHideDuration={3000}
        onClose={() => setSignInOpen(false)}
        anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
      >
        <Alert
          onClose={() => setSignInOpen(false)}
          severity="info"
          sx={{ width: '100%' }}
        >
          {signInMessage}
        </Alert>
      </Snackbar>
      {isLoading ? (
        <Box
          display="flex"
          justifyContent="center"
          alignItems="center"
          width="100px"
          height="100px"
          margin="auto"
        >
          <CircularProgress />
        </Box>
      ) : cookie ? (
        <UserProfile
          onVerify={onVerify}
          onSignIn={onSignIn}
          onLogout={onLogout}
          onClose={onClose}
          sign={cookie.sign}
          username={cookie.username}
          isVIP={cookie.isvip}
          vipExpire={cookie.expire}
          downloadsRemaining={10 - cookie.download}
          silverCoins={cookie.silver}
          goldCoins={cookie.gold}
          isVerified={cookie.userid || false}
        />
      ) : (
        <Box>
          {showToast && <CenteredToast message='注册成功' onClose={() => setShowToast(false)} />}
          {showToastLogin && <CenteredToast message='登陆成功' onClose={() => setShowToastLogin(false)} />}
          {showToastLoginFalse && <CenteredToast message='用户名或密码错误' onClose={() => setShowToastLoginFalse(false)} />}
          <DialogTitle>用户登录/注册</DialogTitle>
          <DialogContent>
            <Tabs value={activeTab} onChange={handleTabChange}>
              <Tab label="登录" />
              <Tab label="注册" />
            </Tabs>

            {activeTab === 0 && (
              <Box>
                <TextField
                  margin="dense"
                  label={usernameError || '用户名'}
                  error={!!usernameError}
                  type="text"
                  fullWidth
                  value={username}
                  onChange={(e) => setUsername(e.target.value)}
                />
                <TextField
                  margin="dense"
                  label={passwordError || '密码'}
                  error={!!passwordError}
                  type="password"
                  fullWidth
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                />
                <Box mt={2}>
                  <Turnstile
                    language="zh"
                    sitekey={process.env.REACT_APP_API_KEY}
                    onSuccess={setTurnstileToken}
                    onError={() => setTurnstileError('验证码加载失败')}
                    ref={turnstileRef}
                  />
                  {turnstileError && (
                    <div style={{ color: 'red', fontSize: '12px' }}>{turnstileError}</div>
                  )}
                </Box>
              </Box>
            )}

            {activeTab === 1 && (
              <Box>
                <TextField
                  margin="dense"
                  label={usernameError || '用户名'}
                  error={!!usernameError}
                  type="text"
                  fullWidth
                  value={username}
                  onChange={(e) => {
                    setUsername(e.target.value);
                    setPendingField('username');
                  }}
                />
                <TextField
                  margin="dense"
                  label={passwordError || '密码'}
                  error={!!passwordError}
                  type="password"
                  fullWidth
                  value={password}
                  onChange={(e) => {
                    setPassword(e.target.value);
                    setPendingField('password');
                  }}
                />
                <TextField
                  margin="dense"
                  label={confirmPasswordError || '确认密码'}
                  error={!!confirmPasswordError}
                  type="password"
                  fullWidth
                  value={confirmPassword}
                  onChange={(e) => {
                    setConfirmPassword(e.target.value);
                    setPendingField('confirmPassword');
                  }}
                />
                <Box mt={2}>
                  <Turnstile
                    language="zh"
                    sitekey={process.env.REACT_APP_API_KEY}
                    onSuccess={setTurnstileToken}
                    onError={() => setTurnstileError('验证码加载失败')}
                    ref={turnstileRef}
                  />
                  {turnstileError && (
                    <div style={{ color: 'red', fontSize: '12px' }}>{turnstileError}</div>
                  )}
                </Box>
              </Box>
            )}
          </DialogContent>
          <DialogActions>
            <Button onClick={onClose} color="primary">取消</Button>
            {activeTab === 0 ? (
              <Button color="primary" onClick={handleLogin}>登陆</Button>
            ) : (
              <Button color="primary" onClick={handleSubmit}>注册</Button>
            )}
          </DialogActions>
        </Box>
      )}
    </>
  );
}


